// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"ImagePlaceholder_placeholder__1NrW1","small":"ImagePlaceholder_small__2ffdn"};